export const API_URL = process.env.VUE_APP_API_URL || 'http://api.startupact.test';
export const x_api_key = process.env.VUE_APP_X_API_KEY || 'bGHpdZYR2TJHL8LfImy4WnCEAQKdjOdJ';
export default API_URL;
export const PAYMENT_URL = process.env.VUE_APP_PAYMENT_URL || 'http://www.startupact.satoripop.tn/payment';
export const MAIL_SUPPORT = process.env.VUE_APP_MAIL_SUPPORT ||  'support@startupact.tn';